/* eslint-disable @typescript-eslint/naming-convention */
import { Button, Card, Divider, Empty, Modal, Space, Tooltip, Typography } from 'antd'
import {
  BatchOperation,
  FilterForm,
  IconFont,
  SearchInput,
  SignTitle,
  SvgIcon,
  TableTag,
} from '@/components'
import { useDebounceFn, useSelections } from 'ahooks'
import { Checkbox, Form, Input, Pagination } from 'antd'
import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import styled from 'styled-components'
import Scrollbars from 'react-custom-scrollbars'
import Header from './header'
import { SyncOutlined } from '@ant-design/icons'
import { useExportData, useGetSource, usePostCollectList } from './utils'
import { PostCollect } from '@/api/phishing-mail-collect'
import { useGetDomain, usePutName } from '../target/utils'
import { Custom } from './custom'
import { useNavigate } from 'react-router-dom'
import EmptyImg from '@/assets/imges/Empty/Empty.png'
import { CreateReport } from '@/components/create-report'
import { useAddReport } from '@/pages/evaluation/report-task/utils'
import { t } from '@/i18n'

const MailCollectTemplate = () => {
  const { useForm } = Form
  const navigate = useNavigate()
  const [getTaskListParams, setGetTaskListParams] = useState<PostCollect>({
    limit: 10,
    page: 1,
  })
  const [visible, setVisible] = useState({ visible: false, ids: [] })
  const visibleClose = (data: boolean) => {
    if (data) {
      postCollectList()
      setSelected([])
    }
    setVisible({ visible: false, ids: [] })
  }
  const [collectList, collectListLoad, postCollectList] = usePostCollectList({
    postCollectListParams: getTaskListParams,
  })
  const [exportData] = useExportData()
  const [getDomain, targetDomain] = useGetDomain()
  const ids = useMemo(() => collectList?.items?.map(item => item?.id) || [], [collectList])
  const {
    selected,
    allSelected,
    setSelected,
    isSelected,
    toggle,
    toggleAll,
    unSelectAll,
    partiallySelected,
  } = useSelections(ids || [])
  const { run: searchTask } = useDebounceFn(
    (name: string) => {
      setGetTaskListParams(origin => ({
        ...origin,
        page: 1,
        name_keyword: name,
        email_keyword: name,
      }))
    },
    {
      wait: 300,
    },
  )
  const memoOpt = useMemo(() => {
    const memo = {
      name_keyword: {
        label: t('邮箱/姓名'),
        type: 'input',
      },
      time: {
        label: t('收集时间'),
        type: 'date',
        apiParams: ['start_time', 'end_time'],
      },
    }
    if (targetDomain.length > 0) {
      let arr = []
      for (let index = 0; index < targetDomain.length; index++) {
        let obj: any = {}
        obj.name = targetDomain[index].domain
        obj.id = targetDomain[index].id
        arr.push(obj)
      }
      memo.domain_id = { label: t('域名'), type: 'multiple', data: arr, typeof: 'array' }
    }
    return memo
  }, [targetDomain])

  const handleConfirm = useCallback(e => {
    const { time, domain } = e
    setGetTaskListParams(origin => ({
      ...origin,
      start_time: time ? time[0] : null,
      end_time: time ? time[1] : null,
      domain_id: domain,
      page: 1,
    }))
  }, [])

  // const TableItem = props => {
  const [getSource, sourceList, sourceLoading] = useGetSource()
  const [putName] = usePutName()
  let [isCollapse, setIsCollapse] = useState(false)
  let [currentId, setCurrentId] = useState()
  let [isEdit, setIsEdit] = useState(false)
  const inputRef = useRef(null)

  useEffect(() => {
    if (isCollapse) {
      getSource({ target_id: currentId })
        .then(() => {})
        .catch(() => {})
    }
  }, [currentId])

  // 生成报表
  const [createForm] = useForm()
  const [getTaskReport, createLoading] = useAddReport()
  const [statement, setStatement] = useState({ visible: false })
  const confirmAddGroup = async (values: any) => {
    console.log(values)

    const { report_name } = values
    try {
      await getTaskReport({
        campaign_type: 6,
        ...values,
      })
        .then(res => {
          window.open('/report/task/task-report?tab=6', '_self')
        })
        .catch(res => {})
    } catch (error) {}
  }
  return (
    <MainContainer
      actions={[
        collectList?.items?.length > 0 && (
          <PaginationStyle>
            <Pagination
              total={collectList?.total}
              current={getTaskListParams.page}
              pageSize={getTaskListParams.limit}
              showSizeChanger
              showQuickJumper
              pageSizeOptions={['10', '20', '50', '100']}
              showTotal={total => `${t('共')} ${total} ${t('条')}`}
              onChange={(page, pageSize) => {
                setGetTaskListParams(origin => ({ ...origin, page, limit: pageSize as number }))
              }}
            />
          </PaginationStyle>
        ),
      ]}
      title={
        <Header
          exportClick={() => {
            if (ids.length > 0) {
              setStatement({ visible: true })
            }
          }}
          idsLength={ids.length}
          refresh={() => {
            postCollectList().catch(_ => {})
          }}
        />
      }
    >
      <Task>
        <FilterForm
          isAside
          option={memoOpt}
          setSearchParams={setGetTaskListParams}
          onReset={() => {
            setGetTaskListParams({
              page: 1,
              limit: 10,
            })
          }}
        />

        <div style={{ padding: '0 20px' }}>
          {' '}
          {!(selected?.length > 0) ? (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: 10,
                paddingLeft: 20,
              }}
            >
              <Checkbox
                indeterminate={!allSelected && selected.length > 0}
                checked={allSelected}
                onChange={() => {
                  toggleAll()
                }}
              >
                {`${t('全选')}（${t('已选')} ${selected.length} ${t('项')}）`}
              </Checkbox>
              <RefreshButton
                // className="refreshButton"
                icon={<SyncOutlined />}
                onClick={() => {
                  postCollectList().catch(_ => {})
                }}
              />
            </div>
          ) : (
            <BatchOperation
              selectedRowKeys={selected}
              batchOperation={
                <Space split={<Divider type={'vertical'} />}>
                  <Checkbox
                    indeterminate={!allSelected && selected.length > 0}
                    checked={allSelected}
                    onChange={() => {
                      toggleAll()
                    }}
                  >
                    {`${t('全选')}（${t('已选')} ${selected.length} ${t('项')}）`}
                  </Checkbox>
                  <Delete
                    onClick={() => {
                      if (selected.length > 0) {
                        setVisible({ ids: selected, visible: true })
                      }
                    }}
                    active={selected?.length > 0}
                  >
                    <SvgIcon
                      name={selected?.length > 0 ? 'batch_remove' : 'batch_remove_ash'}
                      className="icon-delete"
                    />

                    <span>{t('批量添加到')}</span>
                  </Delete>
                </Space>
              }
              setSelectedRowKeys={unSelectAll}
            />
          )}
        </div>
        <TableContainer>
          <Scrollbars>
            {collectList?.items?.map(item => (
              <div key={item.id}>
                <TableItemStyle isCollapse={isCollapse} color={'#4238C9'}>
                  <div className="content">
                    <div className="table-items">
                      <Checkbox
                        className="table-checkbox"
                        checked={isSelected(item.id)}
                        onClick={() => toggle(item.id)}
                      />

                      <div className="table-domain">
                        <Typography.Text
                          ellipsis={{
                            tooltip: { placement: 'top', getPopupContainer: () => document.body },
                          }}
                        >
                          {item.email}
                        </Typography.Text>
                      </div>
                      <div className="table-name">
                        {currentId === item.id && isEdit && !isCollapse ? (
                          <div className="name-input-content">
                            <Input
                              placeholder={t('请输入姓名')}
                              defaultValue={inputRef.current}
                              onChange={e => (inputRef.current = e.target.value)}
                              style={{ width: '240px' }}
                            />

                            <SvgIcon
                              className="icon-name"
                              name={'close'}
                              onClick={() => {
                                setIsEdit(false)
                              }}
                            />

                            <SvgIcon
                              className="icon-name"
                              name={'choose'}
                              onClick={() => {
                                putName({ id: item.id, name: inputRef.current })
                                  .then(res => {
                                    postCollectList()
                                    setIsEdit(false)
                                  })
                                  .catch(res => {})
                              }}
                            />
                          </div>
                        ) : (
                          <div>
                            <span
                              style={{
                                color: '#666666',
                              }}
                            >
                              {t('姓名：')}
                            </span>
                            <Typography.Text
                              ellipsis={{
                                tooltip: {
                                  placement: 'top',
                                  getPopupContainer: () => document.body,
                                },
                              }}
                              style={{ maxWidth: 'calc(100% - 70px)' }}
                            >
                              {item.name ? item.name : '-'}
                            </Typography.Text>
                            <IconFont
                              className="icon-bianji"
                              onClick={() => {
                                inputRef.current = item.name
                                setCurrentId(item.id)
                                setIsEdit(true)
                              }}
                              type={'icon-huabanfuben'}
                            />
                          </div>
                        )}
                      </div>
                      <div className="table-collect-time">
                        <span style={{ color: '#666666' }}>{t('收集时间：')}</span>
                        <span>{item.create_time}</span>
                      </div>
                      <div style={{ width: '16%' }}>
                        <Tooltip
                          trigger="click"
                          title={
                            !sourceLoading &&
                            sourceList?.map(i => (
                              <div className="item" style={{ width: '100%' }}>
                                {i.source_url}
                              </div>
                            ))
                          }
                          getPopupContainer={(node: any) =>
                            node?.parentNode
                              ? node.parentNode.parentNode.parentNode.parentNode.parentNode
                                  .parentNode.parentNode.parentNode.parentNode
                              : document.body
                          }
                          // arrowPointAtCenter
                          placement="right"
                          visible={currentId === item.id && isCollapse}
                          onOpenChange={e => {
                            if (!e) {
                              setCurrentId(null)
                              setIsCollapse(false)
                            }
                          }}
                        >
                          <TableTag
                            bgColor="#65BDC0"
                            color="#65BDC0"
                            onClick={() => {
                              if (item.count > 0) {
                                setCurrentId(item.id)
                                setIsCollapse(true)
                              }
                            }}
                          >
                            {t('搜索来源：')}
                            {item.count || 0}
                            {t('个')}
                          </TableTag>
                        </Tooltip>
                      </div>
                      <div className="table-inner-toolbar">
                        <div
                          onClick={() => {
                            setVisible({ ids: [item.id], visible: true })
                          }}
                          className="icon-add-box"
                        >
                          <IconFont className="icon-add" type={'icon-new'} />{' '}
                          <span>{t('添加到')}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </TableItemStyle>
              </div>
            )) || <Empty image={EmptyImg} />}
          </Scrollbars>
        </TableContainer>
        <CreateReport
          visible={statement.visible}
          createLoading={createLoading}
          templateType={6}
          onConfirm={e => confirmAddGroup(e)}
          onCancel={() => setStatement({ visible: false })}
          showSelect={false}
        />
      </Task>
      <Custom custom={visible} cancel={visibleClose} />
    </MainContainer>
  )
}

interface DeleteItem {
  active: boolean
}
const Delete = styled.div<DeleteItem>`
  width: 110px;
  height: 24px;
  font-size: 14px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #333;
  justify-content: center;
  transition: 0.3s;
  &:hover {
    background-color: #fff;
  }
  .icon-delete {
    width: 12px;
    transition: 0.3s;
    height: 12px;
    margin-right: 3px;
  }
`

const Task = styled.div`
  flex-grow: 1;
  //display: flex;
  height: 100%;
  //flex-wrap: wrap;
  //align-content: space-between;
  .ant-dropdown-menu {
    padding: 4px;
  }
  .ant-dropdown-menu-item {
    border-radius: 4px;
    padding: 0;
    &:hover {
      color: #4238c9;
      background-color: #e7e9f3;
    }
  }
  .operate {
    width: 110px;
    height: 30px;
    display: flex;
    align-items: center;
    padding: 5px 12px;
    gap: 8px;
  }
`

const MainContainer = styled(Card)`
  min-height: 100%;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0px 4px 8px 0px rgba(95, 103, 129, 0.06);
  .bottom {
    align-items: flex-end;
    margin-bottom: 6px;
  }
  .ant-table-thead > tr > th {
    font-weight: 600;
  }
  .ant-table {
    margin-bottom: 24px;
  }
  .ant-table-tbody > tr.ant-table-row-selected > td {
    background-color: rgba(0, 0, 0, 0.03);
  }
  .ant-card-body {
    padding: 16px 0px 0px 0px;
  }
  .ant-tooltip-inner {
    max-height: 200px;
    overflow-y: auto;
  }
`
const Container = styled.div`
  /* height: 100%; */
`
interface OperationProps {
  active: boolean
  idsLength: number
}
const Operation = styled.div<OperationProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  border-radius: 6px;
  .check-all {
    /* width: 181px; */
    line-height: 21px;
  }
  .toolbar {
    display: flex;
  }
  .export-data {
    display: flex;
    align-items: center;
    cursor: pointer;
    cursor: ${props => (props.idsLength > 0 ? 'pointer' : 'no-drop')};
  }
  .batch-add {
    display: flex;
    align-items: center;
    cursor: ${props => (props.active ? 'pointer' : 'no-drop')};
  }
  .batch-add {
    margin-right: 20px;
  }
  .icon {
    width: 16px;
    transition: 0.3s;
    height: 16px;
    margin-right: 6px;
  }
  .add-text,
  .export-text {
    font-size: 14px;
    font-family: SourceHanSansCN-Normal, SourceHanSansCN;
    font-weight: 400;
    color: ${props => (props.active ? '#333' : '#999')};
  }
  .add-text {
    &:hover {
      color: ${props => props.active && '#253aa3'};
    }
  }
  .export-text {
    color: ${props => (props.idsLength > 0 ? '#333' : '#999')};
    &:hover {
      color: ${props => props.idsLength > 0 && '#253aa3'};
    }
  }
`
const TableContainer = styled.div`
  height: calc(100% - 80px);
  font-size: 14px;
  font-family: SourceHanSansCN-Normal, SourceHanSansCN;
  font-weight: 400;
  color: #333333;
  line-height: 20px;
  padding: 0 20px;
`
interface TableItemStyleProps {
  color: string
  isCollapse: boolean
}
const TableItemStyle = styled.div<TableItemStyleProps>`
  width: 100%;
  margin-top: 10px;
  .content {
    z-index: 5;
    position: relative;
    height: 54px;
    background: #f8f9fb;
    border-radius: 8px;
    transform: translateX(3px);
  }
  .table-items {
    height: 54px;
    margin-left: 17px;
    display: flex;
    align-items: center;
    .table-checkbox {
      margin-right: 24px;
    }
    .table-domain {
      /* max-width: 200px; */
      width: 25%;
    }
    .table-name {
      /* max-width: 250px; */
      width: 25%;
      .name-input-content {
        display: flex;
        align-items: center;
        gap: 12px;
        .icon-name {
          width: 16px;
          height: 16px;
          color: #666;
          cursor: pointer;
        }
        .ant-input {
          width: 140px;
          background-color: #f8f9fb;
        }
      }
      .icon-bianji {
        margin-left: 6px;
        font-size: 16px;
        color: #999;
        cursor: pointer;
        &:hover {
          color: #4238c9;
        }
      }
    }
    .table-collect-time {
      /* max-width: 280px; */
      width: 250px;
    }
    .table-inner-toolbar {
      height: 20px;
      width: 200px;
      display: flex;
      align-items: center;
      color: #4238c9;
      justify-content: flex-start;
      .icon-add-box {
        white-space: nowrap;
        cursor: pointer;
      }
      .icon-add {
        height: 20px;
        padding-top: 4px;
        cursor: pointer;
      }
      .icon-zhankai {
        margin-left: 50px;
        font-size: 20px;
        cursor: pointer;
        transition: all 0.2s;
        transform: ${props => (props.isCollapse ? 'rotate(180deg)' : 'none')};
      }
    }
  }
  &::before {
    z-index: 1;
    content: '';
    width: 18px;
    height: 54px;
    position: absolute;
    background: ${props => props.color};
    box-shadow: 0px 2px 4px 0px rgba(95, 103, 129, 0.06);
    border-radius: 8px;
  }
`
const PaginationStyle = styled.div`
  margin-top: 18px;
  padding-right: 20px;
  float: right;
`
const TopBar = styled.div`
  height: 32px;
  background: #f1f3f8;
  border-radius: 6px;
  border: 1px solid #d3d5e6;
  margin-top: 13px;
  margin-bottom: 10px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .flex {
    display: flex;
    align-items: center;
  }
  .box-item {
    padding: 4px 5px;
    border-radius: 6px;
    &:hover {
      background-color: #ffffff;
    }
  }
  .icon-delete {
    width: 12px;
    transition: 0.3s;
    height: 12px;
    margin-right: 3px;
  }
  .end {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    cursor: pointer;
    &:hover {
      background: #ffffff;
    }
    &:active {
      box-shadow: 0px 0px 8px 2px #fffffff7;
    }
  }
  .close {
    font-size: 12px;
    color: #999999;
  }
`
const RefreshButton = styled(Button)`
  border: 0;
  background: #f1f3f8;
  :hover {
    background: #e2e4f6;
  }
`

export default MailCollectTemplate
